/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link, useLocation} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {KTSVG, toAbsoluteUrl} from '../../../helpers'
import {AsideMenu} from './AsideMenu'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'

const AsideDefault: FC = () => {
  const {classes} = useLayout()
  // const {config, classes} = useLayout()
  // const {aside} = config
  const {pathname} = useLocation()
  const store = useSelector<RootState>(({auth}) => auth.user?.store) as any
  const {permissions} = store

  return (
    <div
      id='kt_aside'
      className={clsx('aside', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'200px', '300px': '250px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo flex-column-auto' id='kt_aside_logo'>
        {/* begin::Logo */}

        <Link to='/'>
          <img alt='Logo' className='logo' src={toAbsoluteUrl('/media/logos/logo.svg')} />
          <img className='login-icon' src={toAbsoluteUrl('/media/logos/fav_trans.png')} alt='' />
        </Link>

        {/* end::Logo */}

        {/* begin::Aside toggler */}
        {/* {aside.minimize && (
          <div
            id='kt_aside_toggle'
            className='btn btn-icon w-auto px-0 btn-active-color-primary aside-toggle'
            data-kt-toggle='true'
            data-kt-toggle-state='active'
            data-kt-toggle-target='body'
            data-kt-toggle-name='aside-minimize'
          >
            <KTSVG
              path={'/media/icons/duotune/arrows/arr080.svg'}
              className={'svg-icon-1 rotate-180'}
            />
          </div>
        )} */}
        {/* end::Aside toggler */}
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid'>
        <AsideMenu asideMenuCSSClasses={classes.asideMenu} />
      </div>

      {/* end::Aside menu */}
      {permissions.includes('settings') && (
        <div className='justify-content-end'>
          <div className='aside-menu flex-column-fluid' id='kt_aside_footer'>
            <div className='separator border-2' />
            <div className='menu'>
              <div className='menu-item '>
                <Link
                  to='/settings/store'
                  className={clsx('menu-link without-sub w-100', {
                    active: pathname.includes('settings'),
                  })}
                >
                  <span className='menu-icon'>
                    <KTSVG path='/media/icons/corksy/setting.svg' className='svg-icon-1 me-1' />
                  </span>
                  <span className='menu-title py-6 ms-1'>Settings</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export {AsideDefault}
